import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Eye, EyeOff, Save, Loader2 } from "lucide-react";

const SECTIONS = [
  { k: "about", l: "O hře (Escapecore / Psychoactive / příběh)" },
  { k: "nightvision", l: "Noční vidění (70 %)" },
  { k: "gameinfo", l: "Info o hře / Spis + bezpečnost" },
  { k: "chair", l: "Foto křesla + slogan" },
  { k: "gallery", l: "Galerie polaroidů" },
  { k: "reviews", l: "Recenze" },
  { k: "booking", l: "Rezervace" },
  { k: "vouchers", l: "Dárkové poukazy" },
  { k: "faq", l: "Časté dotazy (FAQ)" },
  { k: "contact", l: "Kontakt" },
  { k: "social", l: "Sociální sítě (sekce + odkaz v menu)" },
  { k: "chatbot", l: "Chatbota (živý chat vpravo dole)" },
];

export default function AdminSections() {
  const [vis, setVis] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/settings").then(({ data }) => setVis(data.section_visibility || {})).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const toggle = (k, v) => setVis((p) => ({ ...p, [k]: v }));

  const save = async () => {
    setSaving(true);
    try { await api.put("/admin/settings", { section_visibility: vis }); toast.success("Viditelnost sekcí uložena."); }
    catch (e) { toast.error("Uložení selhalo."); }
    finally { setSaving(false); }
  };

  if (loading) return <div className="p-4 text-neutral-500 flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" /> Načítám…</div>;

  return (
    <div className="border border-white/10 bg-[#0b0a09] p-5 space-y-3" data-testid="admin-sections">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-head text-lg text-neutral-100">Viditelnost sekcí webu</h3>
          <p className="text-xs text-neutral-500">Vypni sekci a na webu zmizí. Zapni a zase se zobrazí.</p>
        </div>
        <button onClick={save} disabled={saving} data-testid="save-sections-btn" className="hud-btn vhs-btn flex items-center gap-2 px-4 py-2 text-sm font-head">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Uložit
        </button>
      </div>
      <div className="grid sm:grid-cols-2 gap-2">
        {SECTIONS.map((s) => {
          const on = vis[s.k] !== false;
          return (
            <label key={s.k} data-testid={`section-toggle-${s.k}`}
              className="flex items-center justify-between gap-3 border border-white/10 px-3 py-2 bg-black">
              <span className="flex items-center gap-2 text-sm text-neutral-300">
                {on ? <Eye className="w-4 h-4 text-nv" /> : <EyeOff className="w-4 h-4 text-neutral-600" />}
                {s.l}
              </span>
              <Switch checked={on} onCheckedChange={(v) => toggle(s.k, v)} />
            </label>
          );
        })}
      </div>
    </div>
  );
}
